/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollToPlugin);
const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Anchors
    const anchors = document.querySelectorAll("a[href^='#']:not(.no-scroll)");
    if (anchors) {
      anchors.forEach((anchor) => {
        anchor.addEventListener("click", (e) => {
          e.preventDefault();
          const href = anchor.getAttribute("href");
          if (href == "#") return;
          const target = document.querySelector(href);
          if (target) {
            gsap.to(window, {
              scrollTo: target,
              ease: "expo.out",
              duration: 1,
            });
          }
        });
      });
    }

    // Toggle menu
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();

          HTML.classList.toggle("open-menu");
        });
      });
    }

    // Sub-menu
    const hasChildrens = document.querySelectorAll(".menu-item-has-children");
    // if (hasChildrens) {
    //   hasChildrens.forEach((children) => {
    //     const link = children.querySelector("a");
    //     link.addEventListener("click", (e) => {
    //       e.preventDefault();

    //       children.classList.toggle("hover");
    //     });

    //     link.addEventListener("mouseleave", (e) => {
    //       children.classList.remove("hover");
    //     });
    //   });
    // }

    // Main header
    const header = document.querySelector(".main-header");
    if (false && header) {
      let lastScroll = 0;
      window.addEventListener("scroll", () => {
        if (
          window.scrollY > lastScroll &&
          window.scrollY > header.offsetHeight
        ) {
          header.classList.add("scrolling-down");
          HTML.classList.remove("open-menu");
        } else {
          header.classList.remove("scrolling-down");
        }

        if (
          document.body.classList.contains("header-hide") &&
          window.scrollY < header.offsetHeight
        ) {
          header.classList.add("header-hide");
          HTML.classList.remove("open-menu");
        } else if (window.scrollY < lastScroll) {
          header.classList.remove("header-hide");
        }

        lastScroll = window.scrollY;
      });

      window.dispatchEvent(new Event("scroll"));
    }

    this.maskLines();
    this.accordion();
    this.tabsSticky();
    this.postIt();
    this.baseline();
    this.marquee();
    this.textareaResize();
    this.inViewport();
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((el) => {
        const triggers = el.querySelectorAll(".accordion-header");
        const items = el.querySelectorAll(".accordion-item");
        const contents = el.querySelectorAll(".accordion-content");

        if (triggers) {
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();

              if (contents[i]) {
                const active = items[i].classList.contains("active");
                gsap.to(contents[i], {
                  ease: "circ.inOut",
                  duration: 0.3,
                  height: active ? 0 : contents[i].children[0].offsetHeight,
                  autoAlpha: active ? 0 : 1,
                });

                items[i].classList.toggle("active");
              }
            });
          });
        }
      });
    }
  }

  maskLines() {
    const elts = document.querySelectorAll(".mask-lines");

    if (elts) {
      elts.forEach((el) => {
        const hover = el.cloneNode(true);
        gsap.set(hover, {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        });
        el.parentElement.append(hover);

        gsap.set(el, {
          opacity: 0.2,
        });
        new SplitText(el, {
          type: "lines",
        });
        const split = new SplitText(hover, {
          type: "lines",
        });
        el.classList.add("ready");
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top 65%",
            end: "+=120% 65%",
            scrub: true,
            markers: false,
          },
        });

        split.lines.forEach((target) => {
          target.style.clipPath = "polygon(0 0, 0 0, 0 100%, 0% 100%)";
          tl.to(target, {
            clipPath: "polygon(0 0, 110% 0, 110% 100%, 0 100%)",
            ease: "none",
          });
        });
      });
    }
  }

  tabsSticky() {
    if (window.innerWidth < 992) return false;

    const elts = document.querySelectorAll(".tabs-sticky");

    if (elts) {
      elts.forEach((el) => {
        const tabs = el.querySelectorAll(".tabs");
        if (tabs) {
          tabs.forEach((tab, i) => {
            ScrollTrigger.create({
              trigger: tab,
              start: "center center",
              endTrigger: el,
              end: "bottom bottom", // l'effet dure jusqu’à ce que la .container sorte de la vue
              pin: true,
              pinSpacing: false,
            });
          });
        }
      });
    }
  }

  postIt() {
    const elts = document.querySelectorAll(".post-its");

    if (elts) {
      elts.forEach((el) => {
        const postIts = el.querySelectorAll(".post-it");
        if (postIts) {
          const contents = el.querySelectorAll(".content");
          // Set the post-it sizes
          let maxHeight = 0;
          window.addEventListener("resize", () => {
            contents.forEach((content) => {
              if (content.offsetHeight > maxHeight) {
                maxHeight = content.offsetHeight;
              }
            });
            gsap.set(contents, {
              height: `${maxHeight}px`,
            });
          });
          window.dispatchEvent(new Event("resize"));

          postIts.forEach((postIt, i) => {
            ScrollTrigger.create({
              trigger: postIt,
              start: "center center",
              endTrigger: el,
              end: "bottom bottom", // l'effet dure jusqu’à ce que la .container sorte de la vue
              pin: true,
              pinSpacing: false,
            });
          });
        }
      });
    }
  }

  marquee() {
    const elts = document.querySelectorAll(".marquee:not(.ready)");

    if (elts) {
      elts.forEach((el) => {
        el.classList.add("ready");
        const line = el.querySelector(".line");

        let scrollDirection = Number(el.dataset.dir ? el.dataset.dir : 1); // 1 = gauche, -1 = droite
        const speed = 40; // Pixels par seconde

        // Duplique les images pour un effet continu
        const images = line.innerHTML;
        line.innerHTML += images;
        this.lazyload.update();

        // Calcule la largeur totale de la marquee
        const marqueeWidth = line.scrollWidth / 2;

        // Initialise la position
        let position = 0;

        let cursor = 0;

        // Animation continue
        const animate = (timestamp) => {
          position += (speed / 100) * -scrollDirection; // Ajuste selon la vitesse et direction

          // Réinitialise la position si elle dépasse la largeur totale
          if (position <= -marqueeWidth) {
            position = 0;
          } else if (position >= 0) {
            position = -marqueeWidth;
          }

          line.style.transform = `translateX(${position}px)`;
          cursor = requestAnimationFrame(animate);
        };

        // Écouteur pour changer la direction en fonction du scroll
        let lastScrollY = window.scrollY;
        window.addEventListener("scroll", () => {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY) {
            scrollDirection = Number(el.dataset.dir ? el.dataset.dir : 1); // Scroll vers le bas : gauche
          } else if (currentScrollY < lastScrollY) {
            scrollDirection = -Number(el.dataset.dir ? el.dataset.dir : 1); // Scroll vers le haut : droite
          }
          lastScrollY = currentScrollY;
        });

        if (el.dataset.hover) {
          el.addEventListener("mouseenter", () => {
            cancelAnimationFrame(cursor);
          });
          el.addEventListener("mouseleave", () => {
            cursor = requestAnimationFrame(animate);
          });
        }

        // Lance l'animation
        cursor = requestAnimationFrame(animate);
      });
    }
  }

  baseline() {
    const elts = document.querySelectorAll(".baseline");

    if (elts) {
      elts.forEach((el) => {
        const lines = el.querySelectorAll(".baseline-line");
        const tl = gsap.timeline({
          paused: true,
          scrollTrigger: {
            trigger: el,
            start: "+=70% bottom",
            end: "bottom top",
            scrub: false,
            markers: false,
          },
        });
        if (lines.length > 0) {
          lines.forEach((line, i) => {
            const words = line.querySelectorAll(".baseline-word");

            words.forEach((word, j) => {
              if (j % 2 == 0) {
                gsap.set(word, {
                  x:
                    Number.parseFloat(gsap.getProperty(word, "paddingRight")) /
                    2,
                });
              } else {
                gsap.set(word, {
                  x:
                    -Number.parseFloat(gsap.getProperty(word, "paddingLeft")) /
                    2,
                });
              }
            });

            tl.from(
              words,
              {
                y: "40%",
                ease: "expo.out",
                autoAlpha: 0,
                duration: 0.7,
                stagger: 0.1,
                onComplete: () => {
                  words.forEach((word, j) => {
                    gsap.to(word, {
                      x: "0%",
                      ease: "circ.inOut",
                      duration: 0.7,
                    });
                  });
                },
              },
              `start+=${0.15 * i}`
            );

            // if (words) {
            //   words.forEach((word) => {
            //     tl.from(
            //       word,
            //       {
            //         padding: "0%",
            //       },
            //       `start+=${0.1 * i + 0.3}`
            //     );
            //   });
            // }
          });
        }

        el.addEventListener("inview", () => {
          setTimeout(() => {});
          // tl.play();
        });
      });
    }
  }

  textareaResize() {
    /**
     * Textarea
     */
    // expand height textarea
    function autoExpand(field) {
      // Reset field height
      field.style.height = "inherit";

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height =
        Number.parseInt(computed.getPropertyValue("border-top-width"), 10) +
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        Number.parseInt(computed.getPropertyValue("border-bottom-width"), 10);

      field.style.height = `${height}px`;
    }

    document.addEventListener("input", (event) => {
      if (event.target.tagName.toLowerCase() !== "textarea") return;
      autoExpand(event.target);
    });
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
